/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const DEPLOYMENT_DESCRIPTOR = `apiVersion: v1
kind: Namespace
metadata:
  name: <INSERT_NAMESPACE>
---
apiVersion: v1
kind: Secret
metadata:
  name: nordcloud-scanner-secrets
  namespace: <INSERT_NAMESPACE>
type: Opaque
stringData:
  sastoken: <INSERT_SAS_TOKEN>
  queuename: <INSERT_QUEUE_NAME>
  scannerkey: <INSERT_SCANNER_KEY>
---
apiVersion: v1
kind: ConfigMap
metadata:
  name: nordcloud-scanner-config-map
  namespace: <INSERT_NAMESPACE>
data:
  customer-id: <INSERT_CUSTOMER_ID>
  cloud-account: <INSERT_CLOUD_ACCOUNT>
  re-sync-in-s: "3600"
  provider: <INSERT_PROVIDER>
  platform: <INSERT_PLATFORM>
---
apiVersion: v1
kind: ServiceAccount
metadata:
  namespace: <INSERT_NAMESPACE>
  name: nordcloud-scanner-sa
---
apiVersion: rbac.authorization.k8s.io/v1
kind: ClusterRole
metadata:
  name: nordcloud-scanner-cluster-role
rules:
  - apiGroups:
      - ""
    resources:
      - namespaces
      - nodes
      - persistentvolumes
      - pods
      - services
      - persistentvolumeclaims
      - replicationcontrollers
    verbs:
      - list
      - watch
  - apiGroups:
      - "apps"
    resources:
      - deployments
      - replicasets
      - statefulsets
      - daemonsets
    verbs:
      - list
      - watch
  - apiGroups:
      - "networking.k8s.io"
    resources:
      - ingresses
    verbs:
      - list
      - watch
  - apiGroups:
      - "batch"
    resources:
      - cronjobs
      - jobs
    verbs:
      - list
      - watch
  - apiGroups:
      - "route.openshift.io"
    resources:
      - routes
    verbs:
      - list
      - watch
  - apiGroups:
      - "kubevirt.io"
    resources:
      - virtualmachines
      - virtualmachineinstances
      - virtualmachineinstancemigrations
      - virtualmachineinstancepresets
      - virtualmachineinstancereplicasets
    verbs:
      - list
      - watch
  - apiGroups:
      - "snapshot.kubevirt.io"
    resources:
      - virtualmachinerestores
      - virtualmachinesnapshots
      - virtualmachinesnapshotcontents
    verbs:
      - list
      - watch
---
apiVersion: rbac.authorization.k8s.io/v1
kind: ClusterRoleBinding
metadata:
  name: nordcloud-scanner-cluster-role-binding
roleRef:
  apiGroup: rbac.authorization.k8s.io
  kind: ClusterRole
  name: nordcloud-scanner-cluster-role
subjects:
  - apiGroup: ""
    kind: ServiceAccount
    name: nordcloud-scanner-sa
    namespace: <INSERT_NAMESPACE>
---
apiVersion: apps/v1
kind: Deployment
metadata:
  namespace: <INSERT_NAMESPACE>
  name: nordcloud-scanner
  labels:
    app: nordcloud-scanner
spec:
  replicas: 1
  selector:
    matchLabels:
      app: nordcloud-scanner
  template:
    metadata:
      labels:
        app: nordcloud-scanner
    spec:
      serviceAccountName: nordcloud-scanner-sa
      containers:
        - name: nordcloud-scanner
          image: ncpatpublic.azurecr.io/scanner:latest
          imagePullPolicy: Always
          env:
            - name: PLATFORM
              valueFrom:
                configMapKeyRef:
                  key: platform
                  name: nordcloud-scanner-config-map
            - name: PROVIDER
              valueFrom:
                configMapKeyRef:
                  key: provider
                  name: nordcloud-scanner-config-map
            - name: LOGGING_LEVEL_COM_IBM_NORDCLOUD
              value: "DEBUG"
            - name: AZURE_QUEUE_SAS
              valueFrom:
                secretKeyRef:
                  key: sastoken
                  name: nordcloud-scanner-secrets
            - name: AZURE_QUEUE_NAME
              valueFrom:
                secretKeyRef:
                  key: queuename
                  name: nordcloud-scanner-secrets
            - name: SCANNER_KEY
              valueFrom:
                secretKeyRef:
                  key: scannerkey
                  name: nordcloud-scanner-secrets
            - name: RESYNC_IN_SECONDS
              valueFrom:
                configMapKeyRef:
                  key: re-sync-in-s
                  name: nordcloud-scanner-config-map
            - name: CLOUD_ACCOUNT
              valueFrom:
                configMapKeyRef:
                  key: cloud-account
                  name: nordcloud-scanner-config-map
            - name: CUSTOMER_ID
              valueFrom:
                configMapKeyRef:
                  key: customer-id
                  name: nordcloud-scanner-config-map`;

export const METRICS_EXPORTER = `
---
apiVersion: v1
kind: ConfigMap
metadata:
  name: nordcloud-metrics-exporter-config-map
  namespace: <INSERT_NAMESPACE>
data:
  customer-id: <INSERT_CUSTOMER_ID>
  cloud-account: <INSERT_CLOUD_ACCOUNT>
  prometheus-endpoint: "http://nordcloud-prometheus-service:9090"
---
apiVersion: v1
kind: Secret
metadata:
  name: nordcloud-metrics-exporter-secrets
  namespace: <INSERT_NAMESPACE>
type: Opaque
stringData:
  sas-token: <INSERT_STORAGE_SAS_TOKEN>
  storage-name: <INSERT_STORAGE_NAME>
---
apiVersion: batch/v1
kind: CronJob
metadata:
  name: nordcloud-metrics-exporter-cronjob
  namespace: <INSERT_NAMESPACE>
spec:
  schedule: "0 3 * * *"
  successfulJobsHistoryLimit: 1
  failedJobsHistoryLimit: 2
  jobTemplate:
    spec:
      template:
        spec:
          restartPolicy: OnFailure
          containers:
            - name: metrics-exporter
              image: ncpatpublic.azurecr.io/metrics-exporter:latest
              imagePullPolicy: Always
              env:
                - name: KLARITY_SAS_TOKEN
                  valueFrom:
                    secretKeyRef:
                      key: sas-token
                      name: nordcloud-metrics-exporter-secrets
                - name: KLARITY_STORAGE_NAME
                  valueFrom:
                    secretKeyRef:
                      key: storage-name
                      name: nordcloud-metrics-exporter-secrets
                - name: KLARITY_CUSTOMER_ID
                  valueFrom:
                    configMapKeyRef:
                      key: customer-id
                      name: nordcloud-metrics-exporter-config-map
                - name: KLARITY_ACCOUNT_ID
                  valueFrom:
                    configMapKeyRef:
                      key: cloud-account
                      name: nordcloud-metrics-exporter-config-map
                - name: PROMETHEUS_ENDPOINT
                  valueFrom:
                    configMapKeyRef:
                      key: prometheus-endpoint
                      name: nordcloud-metrics-exporter-config-map`;

export const PROMETHEUS_DEPLOYMENT = `
---
apiVersion: rbac.authorization.k8s.io/v1
kind: ClusterRole
metadata:
  name: nordcloud-prometheus
rules:
  - apiGroups: [""]
    resources:
      - namespaces
      - nodes
      - nodes/proxy
      - services
      - endpoints
      - pods
    verbs: ["get", "list", "watch"]
  - apiGroups:
      - extensions
    resources:
      - ingresses
    verbs: ["get", "list", "watch"]
  - nonResourceURLs: ["/metrics"]
    verbs: ["get"]
---
apiVersion: rbac.authorization.k8s.io/v1
kind: ClusterRoleBinding
metadata:
  name: nordcloud-prometheus
roleRef:
  apiGroup: rbac.authorization.k8s.io
  kind: ClusterRole
  name: nordcloud-prometheus
subjects:
  - kind: ServiceAccount
    name: default
    namespace: <INSERT_NAMESPACE>
---
apiVersion: v1
kind: ConfigMap
metadata:
  name: nordcloud-prometheus-config-map
  labels:
    name: nordcloud-prometheus-config-map
  namespace: <INSERT_NAMESPACE>
data:
  prometheus.yml: |-
    global:
      scrape_interval: 5s
      evaluation_interval: 5s
    scrape_configs:
      - job_name: 'node-exporter'
        kubernetes_sd_configs:
          - role: endpoints
        relabel_configs:
        - source_labels: [__meta_kubernetes_endpoints_name]
          regex: 'node-exporter'
          action: keep
      - job_name: 'kubernetes-apiservers'
        kubernetes_sd_configs:
        - role: endpoints
        scheme: https
        tls_config:
          ca_file: /var/run/secrets/kubernetes.io/serviceaccount/ca.crt
        bearer_token_file: /var/run/secrets/kubernetes.io/serviceaccount/token
        relabel_configs:
        - source_labels: [__meta_kubernetes_namespace, __meta_kubernetes_service_name, __meta_kubernetes_endpoint_port_name]
          action: keep
          regex: default;kubernetes;https
      - job_name: 'kubernetes-nodes'
        scheme: https
        tls_config:
          ca_file: /var/run/secrets/kubernetes.io/serviceaccount/ca.crt
        bearer_token_file: /var/run/secrets/kubernetes.io/serviceaccount/token
        kubernetes_sd_configs:
        - role: node
        relabel_configs:
        - action: labelmap
          regex: __meta_kubernetes_node_label_(.+)
        - target_label: __address__
          replacement: kubernetes.default.svc:443
        - source_labels: [__meta_kubernetes_node_name]
          regex: (.+)
          target_label: __metrics_path__
          replacement: /api/v1/nodes/\${1}/proxy/metrics
      - job_name: 'kubernetes-pods'
        kubernetes_sd_configs:
        - role: pod
        relabel_configs:
        - source_labels: [__meta_kubernetes_pod_annotation_prometheus_io_scrape]
          action: keep
          regex: true
        - source_labels: [__meta_kubernetes_pod_annotation_prometheus_io_path]
          action: replace
          target_label: __metrics_path__
          regex: (.+)
        - source_labels: [__address__, __meta_kubernetes_pod_annotation_prometheus_io_port]
          action: replace
          regex: ([^:]+)(?::\\d+)?;(\\d+)
          replacement: $1:$2
          target_label: __address__
        - action: labelmap
          regex: __meta_kubernetes_pod_label_(.+)
        - source_labels: [__meta_kubernetes_namespace]
          action: replace
          target_label: kubernetes_namespace
        - source_labels: [__meta_kubernetes_pod_name]
          action: replace
          target_label: kubernetes_pod_name
      - job_name: 'kube-state-metrics'
        static_configs:
          - targets: ['kube-state-metrics.kube-system.svc.cluster.local:8080']
      - job_name: 'kubernetes-cadvisor'
        scheme: https
        tls_config:
          ca_file: /var/run/secrets/kubernetes.io/serviceaccount/ca.crt
        bearer_token_file: /var/run/secrets/kubernetes.io/serviceaccount/token
        kubernetes_sd_configs:
        - role: node
        relabel_configs:
        - action: labelmap
          regex: __meta_kubernetes_node_label_(.+)
        - target_label: __address__
          replacement: kubernetes.default.svc:443
        - source_labels: [__meta_kubernetes_node_name]
          regex: (.+)
          target_label: __metrics_path__
          replacement: /api/v1/nodes/\${1}/proxy/metrics/cadvisor
      - job_name: 'kubernetes-service-endpoints'
        kubernetes_sd_configs:
        - role: endpoints
        relabel_configs:
        - source_labels: [__meta_kubernetes_service_annotation_prometheus_io_scrape]
          action: keep
          regex: true
        - source_labels: [__meta_kubernetes_service_annotation_prometheus_io_scheme]
          action: replace
          target_label: __scheme__
          regex: (https?)
        - source_labels: [__meta_kubernetes_service_annotation_prometheus_io_path]
          action: replace
          target_label: __metrics_path__
          regex: (.+)
        - source_labels: [__address__, __meta_kubernetes_service_annotation_prometheus_io_port]
          action: replace
          target_label: __address__
          regex: ([^:]+)(?::\\d+)?;(\\d+)
          replacement: $1:$2
        - action: labelmap
          regex: __meta_kubernetes_service_label_(.+)
        - source_labels: [__meta_kubernetes_namespace]
          action: replace
          target_label: kubernetes_namespace
        - source_labels: [__meta_kubernetes_service_name]
          action: replace
          target_label: kubernetes_name
---
apiVersion: apps/v1
kind: Deployment
metadata:
  name: nordcloud-prometheus-deployment
  namespace: <INSERT_NAMESPACE>
  labels:
    app: nordcloud-prometheus-server
spec:
  replicas: 1
  selector:
    matchLabels:
      app: nordcloud-prometheus-server
  template:
    metadata:
      labels:
        app: nordcloud-prometheus-server
    spec:
      containers:
        - name: prometheus
          image: prom/prometheus
          args:
            - "--config.file=/etc/prometheus/prometheus.yml"
            - "--storage.tsdb.path=/prometheus/"
          ports:
            - containerPort: 9090
          volumeMounts:
            - name: prometheus-config-volume
              mountPath: /etc/prometheus/
            - name: prometheus-storage-volume
              mountPath: /prometheus/
      volumes:
        - name: prometheus-config-volume
          configMap:
            defaultMode: 420
            name: nordcloud-prometheus-config-map

        - name: prometheus-storage-volume
          emptyDir: {}
---
apiVersion: v1
kind: Service
metadata:
  name: nordcloud-prometheus-service
  namespace: <INSERT_NAMESPACE>
spec:
  selector:
    app: nordcloud-prometheus-server
  ports:
    - protocol: TCP
      port: 9090
      targetPort: 9090`;

export const VMWARE_CONFIG_FILE = `{
    "vmware_api_url": "",
    "vmware_api_username": "",
    "vmware_api_password": "",
    "wmvare_api_insecure": true,
    "klarity_customer_id": "<CUSTOMER_ID>",
    "klarity_installation_id": "<ACCOUNT_ID>",
    "klarity_storage_name": "<STORAGE_NAME>",
    "klarity_sas_token": "<SAS_TOKEN>",
    "scanned_objects": [
        "Folder",
        "Network",
        "Datastore",
        "VirtualMachine",
        "HostSystem",
        "ComputeResource"
    ]
}`;
